<div class="row equine-quote-details-row">
  <div class="col-md-8 equine-form-content">
    <div class="form_sections">
      <h4 class="text-white"><u>Premium Summary</u></h4>
      <p *ngIf="quoteRefNumber" class="mb-0 mt-2" style="color: white;"><strong>Quote reference:</strong> {{ quoteRefNumber }}</p>

      <!-- Referred message: show when quote has been referred (manually or automatically) -->
      <div *ngIf="isReferred" class="alert alert-warning mt-3 mb-4">
        <h5 class="alert-heading mb-2"><strong>This quote has been referred to Underwriters</strong></h5>
        <p class="mb-0">
          Due to the information provided, this quote needs to be referred to Underwriters. Please await our quote terms once we have reviewed the risk. We aim to respond within 4 working hours, but please state clearly if you require an urgent quotation for this submission.
        </p>
        <p class="mb-0 mt-2">
          Please add any additional information in the 'notes' box below then click 'Submit for Underwriting'.
        </p>
      </div>

      <!-- Premium details (hide or show TBC when referred) -->
      <div class="form_sections mt-3">
        <h5 class="mb-3 text-white">Premium Details</h5>
        <table class="table table-sm table-bordered premium-summary-table">
          <tbody>
            <tr>
              <td>Premium excluding IPT</td>
              <td class="text-right">{{ showPremiumAsTbc ? 'TBC' : (premiumData?.policy_premium != null ? ('£' + (premiumData.policy_premium | premiumPenceUp | number:'1.2-2')) : '£0.00') }}</td>
            </tr>
            <tr>
              <td>IPT (Insurance Premium Tax) @ 12%</td>
              <td class="text-right">{{ showPremiumAsTbc ? 'TBC' : (premiumData?.ipt != null ? ('£' + (premiumData.ipt | premiumPenceUp | number:'1.2-2')) : '£0.00') }}</td>
            </tr>
            <tr>
              <td>Premium including IPT</td>
              <td class="text-right">{{ showPremiumAsTbc ? 'TBC' : (premiumData?.total_premium != null ? ('£' + (premiumData.total_premium | premiumPenceUp | number:'1.2-2')) : '£0.00') }}</td>
            </tr>
            <tr>
              <td>Peliwica Underwriting Fee</td>
              <td class="text-right">{{ showPremiumAsTbc ? 'TBC' : (premiumData?.uw_fee != null ? ('£' + (premiumData.uw_fee | premiumPenceUp | number:'1.2-2')) : '£0.00') }}</td>
            </tr>
            <tr>
              <td>Total Payable Amount</td>
              <td class="text-right">{{ showPremiumAsTbc ? 'TBC' : (premiumData?.total_payable_amount != null ? ('£' + (premiumData.total_payable_amount | premiumPenceUp | number:'1.2-2')) : '£0.00') }}</td>
            </tr>
          </tbody>
        </table>
      </div>

  

      <!-- Underwriting notes -->
      <div class="form_sections mt-4">
        <h5 class="mb-3 text-white">Underwriting notes</h5>
        <div class="form-group">
          <label class="text-white">Automatic note label</label>
          <div class="form-control bg-light text-dark" style="font-weight: 600;">
            {{ automaticLabelForSummary }}
          </div>
        </div>
        <div class="form-group">
          <label class="text-white">Additional notes</label>
          <textarea
            class="form-control"
            rows="5"
            placeholder="Please add any additional notes here. This is compulsory when submitting a Manual Referral. If this is an Automatic Quote, any notes added will not be reviewed by Peliwica, so please submit the quote as a Manual Referral if you have anything to declare or ask."
            [(ngModel)]="underwritingNotes"
            [ngClass]="{ 'is-invalid': manualReferralAttempted && !hasAdditionalNotes }"
          ></textarea>
          <div class="invalid-feedback" *ngIf="manualReferralAttempted && !hasAdditionalNotes">
            Additional notes are required when submitting a Manual Referral.
          </div>
        </div>
      </div>

      <h3 style="margin-top: 2rem">Referral Reasons</h3>
      <ng-container *ngIf="showReferralReasons">
          <ag-grid-angular 
              style="width: 100%;" 
              class="ag-theme-bootstrap mt-3" 
              [gridOptions]="gridOptions"
              [rowData]="referralReasons" 
              [columnDefs]="referralReasonNotes" 
              animateRows 
              pagination=false 
              paginationPageSize=5 
              rowHeight=27
              headerHeight=35 
              domLayout='autoHeight'
              (rowClicked)='onGridRowClicked($event,notesViewModel)'
          ></ag-grid-angular>
      </ng-container>

      <div class="form_sections mt-4">
        <h5 class="mb-3 text-white">Vulnerability Marker</h5>
        <!-- checkbox to toggle vulnerability marker -->
        <div style="margin-bottom: 1rem">
          <label class="form-check-label" for="vulnerabilityMarker">
            Is this customer showing signs of vulnerability?
          </label>
          <input class="form-check-input" style="margin-left: 1rem" type="checkbox" id="vulnerabilityMarker" [(ngModel)]="vulnerabilityMarker" (change)="!vulnerabilityMarker ? vulnerabilityMarkerDetails = '' : null">
        </div>
        <div class="form-group" *ngIf="vulnerabilityMarker">
          <textarea
            class="form-control"
            rows="4"
            placeholder="Please provide details of the vulnerability (required when submitting for underwriting)"
            [(ngModel)]="vulnerabilityMarkerDetails"
            [ngClass]="{ 'is-invalid': submitted && vulnerabilityMarker && !vulnerabilityMarkerDetails }"
          ></textarea>
          <div class="invalid-feedback" *ngIf="submitted && vulnerabilityMarker && !vulnerabilityMarkerDetails">
            Vulnerability marker details are required.
          </div>
        </div>

      </div>

      <!-- Buttons -->
      <div class="row mt-4">
        <div class="col-md-12">
          <button type="button" class="btn btn-default btn-gray mr-2" (click)="backToStatementOfFacts()">
            Back
          </button>
          <button *ngIf="!isReferred" type="button" class="btn btn-default btn-gray mr-2" (click)="openReferModal()">
            Manually Refer to Underwriter
          </button>
          <button  type="button" class="btn btn-default btn-gray mr-2" (click)="saveAndViewQuote()" [disabled]="saving">
            {{ isReferred ? 'Submit for underwriting' : 'Save & View Quote' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Manually Refer to Underwriter modal -->
<ng-template #referModal>
  <div class="modal-header">
    <h4 class="modal-title">Manually Refer to Underwriter</h4>
    <button type="button" class="close" aria-label="Close" (click)="dismissReferModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p class="text-muted mb-0">
      This will submit the quote as <strong>MANUAL REFERRAL</strong> and use the Additional notes from the summary screen.
    </p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-default btn-gray" (click)="dismissReferModal()">Cancel</button>
    <button type="button" class="btn btn-success" (click)="submitManuallyRefer()">Refer to Underwriter</button>
  </div>
</ng-template>

<ng-template #notesViewModel let-modal>
  <div class="modal-body">
    {{ notesText }}
  </div>
</ng-template>
